import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'

export default class ChangeGroupConfirm extends React.Component {
    render() {
        return <div>
            <h4 className="mar-b25">Confirm Group</h4>
            <div className="mar-b25">We will import your Little Box Office customers into this group and keep them in sync going forward.</div>
            <Button text="Start Sync" className="button-primary" onClick={this.props.changeTheGroup} />
        </div>
    }
}
